import { render } from "./AccountSettingZoom.vue?vue&type=template&id=5f4e63e3"
import script from "./AccountSettingZoom.vue?vue&type=script&lang=js"
export * from "./AccountSettingZoom.vue?vue&type=script&lang=js"

import "./AccountSettingZoom.vue?vue&type=style&index=0&id=5f4e63e3&lang=scss"
script.render = render

export default script